export default __webpack_public_path__ + "static/media/header_text.0ff51a77.png";